import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";

const state = {
  fileApprovals: null,
};

const getters = {
  file_approvals_get: (state) => {
    return state.fileApprovals;
  },
};

const mutations = {
  FILE_APPROVALS_SET_LIST(state, fileApprovals) {
    state.fileApprovals = fileApprovals;
  },
};

const actions = {
  /**
   * Execute an API call for the file approval end point.
   * The following actions are supported:
   *
   * - fileApprovalList
   * - fileApprovalCreate
   * - fileApprovalUpdate
   * - fileApprovalDelete
   * - fileApprovalVersionCreate
   * - fileApprovalVersionUpdate
   * - fileApprovalVersionDelete
   *
   * @param commit
   * @param dispatch
   * @param rootState
   * @param payload
   * @param apiMethod
   * @returns {*}
   */
  fileApprovalApiRequest({ commit, dispatch, rootState }, payload = {}) {
    if (!payload.data) {
      payload.data = {};
    }

    console.log("fileApprovalApiRequest: ", payload);

    return new Promise((resolve, reject) => {
      //!payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          let apiMethod = payload.apiMethod;
          let promise;

          if (apiMethod === "fileApprovalList") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamProjectsProjectFileapprovalsGet(params, payload.data);
          } else if (apiMethod === "fileApprovalCreate") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamProjectsProjectFileapprovalsPost(params, payload.data);
          } else if (apiMethod === "fileApprovalUpdate") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamProjectsProjectFileapprovalsFileApprovalPut(params, payload.data);
          } else if (apiMethod === "fileApprovalDelete") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamProjectsProjectFileapprovalsFileApprovalDelete(params, payload.data);
          } else if (apiMethod === "fileApprovalVersionCreate") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamProjectsProjectFileapprovalsFileApprovalVersionsPost(params, payload.data);
          } else if (apiMethod === "fileApprovalVersionUpdate") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamProjectsProjectFileapprovalsFileApprovalVersionsFileApprovalVersionPut(params, payload.data);
          } else if (apiMethod === "fileApprovalVersionDelete") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamProjectsProjectFileapprovalsFileApprovalVersionsFileApprovalVersionDelete(params, payload.data);
          } else if (apiMethod === "fileApprovalAttachmentGet") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamProjectsProjectFileapprovalsFilesFileGet(params, payload.data);
          } else if (apiMethod === "fileApprovalAttachmentPreviewUrl") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamProjectsProjectFileapprovalsFilesFilePreviewImageRendermethodPageWidthHeightGet(params, payload.data);
          } else {
            console.log("invalid api method: " + apiMethod);
            reject("invalid api method: " + apiMethod);
          }

          promise
            .then((res) => {
              console.log("response of '" + apiMethod + "': ", res);
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },

  createApprovalFileAttachmentFilesRequest({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      //commit("GLOBAL_LOADING_STARTED");
      console.log("createApprovalFileAttachmentFilesRequest", payload);
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFileapprovalsFilesPost(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectFileapprovalsFilesPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },

  updateFileApprovalVersionAttachmentRelation({ commit, dispatch, rootState }, payload = {}) {
    console.log("updateFileApprovalVersionAttachmentRelation", payload);
    return new Promise((resolve, reject) => {
      //!payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      //console.log("createComponentRelation", payload);
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamProjectsProjectFileapprovalsFilesFilePut(params, payload.data)
            .then((res) => {
              console.log("teamProjectsProjectFileapprovalsFilesFilePut", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          //commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
